import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import LoginPage from "../pages/Auth/LoginPage";
import RegisterPage from "../pages/Auth/RegisterPage";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import VerifyAccount from "../pages/Auth/VerifyAccount";
import { ProtectedRoute } from "../pages/Auth/ProtectedRoute";

import { pageRoutes } from "./pageRoutes";
import Exam from "../pages/Applicant/Exam/Exam";
import Applicant from "../pages/Applicant/Applicant";
import UserForm from "../pages/Applicant/UserForm";
import PersonalityExam from "../pages/Applicant/PersonalityExam/PersonalityExam";
import OnewayInterview from "../pages/Applicant/VideoInterview/OnewayInterview";
import OnBoardingExam from "../pages/Applicant/OnBoarding/OnBoardingExam";

const routes = [
  {
    path: "/",
    element: <Outlet />,
    children: [
      { path: pageRoutes.LOGIN, element: <LoginPage /> },
      { path: "register/:id?", element: <RegisterPage /> },
      { path: "account-verify", element: <VerifyAccount /> },
      { path: "forgot-password", element: <ForgotPassword /> },
      { path: "/", element: <Navigate to={pageRoutes.LOGIN} /> },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      { path: "/applicant/:tab?", element: <Applicant /> },
      { path: "/assessment/exam/:id?", element: <Exam /> },
      { path: pageRoutes.PEXAM, element: <PersonalityExam /> },
      { path: pageRoutes.USERFORM, element: <UserForm /> },
      { path: pageRoutes.VIDEOINTERVIEW, element: <OnewayInterview /> },
      { path: pageRoutes.ONBOARDINGEXAM, element: <OnBoardingExam /> },
    ],
  },
];

export default routes;
